import polyglotI18nProvider from 'ra-i18n-polyglot';
import spanishMessages from '../language/es';

const messages = {
  es: spanishMessages,
};

export const i18nProvider = polyglotI18nProvider(
  locale => messages[locale],
  'es',
  { allowMissing: true }
);
